<style lang="scss" scoped>
.chat-modal::v-deep .v--modal-box {
  overflow: visible;
}

.circle {
  border-radius: 100%;
  background-color: $danger;
  transition: background-color 0.3s linear;
  height: 25px;
  width: 25px;
  margin-left: 10px;
  display: inline-table;

  &--online {
    background-color: $green;
  }

  .times-red {
    color: $red;
  }

  .times-black {
    color: $black;
  }
}

.red {
  color: $red;
}
</style>
<template>
  <div v-if="customer">
    <h3>
      {{ customer.name }}
      <div
        v-if="!customer.user.verified"
        class="fas fa-times times-black"
      ></div>
      <div v-else class="circle" :class="{ 'circle--online': online }"></div>
      <span v-if="no_offline_email">
        <s
          ><i
            class="fas fa-envelope red"
            v-tooltip:auto="no_offline_email_tooltip"
          ></i
        ></s>
      </span>
      <span v-if="isDeleted" class="badge badge-deleted ml-3">gelöscht</span>
      <span v-if="isDeletion" class="badge badge-deletion ml-3"
        >in Löschfrist</span
      >
      <span v-if="isDisabled" class="badge badge-disabled ml-3">gesperrt</span>
    </h3>
    <p v-if="isDeleted">Gelöscht am: {{ deleted_at }}</p>
    <p v-if="isDeletion">
      Löschfrist seit: {{ deletion_start_at }}
      <br />
      Bereits in Löschfrist: {{ deletion_time }}
      <br />
      Löschfrist Ende: {{ deletion_end_at }}
    </p>
    <p v-if="isDisabled">
      Gesperrt am: {{ disabled_at }}
      <br />
      Grund: {{ customer.user.disabled_message }}
    </p>
    <div class="d-flex">
      <div class="flex-grow-1">
        <h4>
          <span v-if="isUnsubscribed" class="badge badge-warning ml-3"
            >unsubscribed</span
          >
        </h4>
      </div>
      <div v-if="!isDeleted">
        <button @click="loginAsUser()" class="btn btn-primary">
          Einloggen als
        </button>
        <button @click="$modal.show(openChatModalName)" class="btn btn-primary">
          Nachricht senden
        </button>
        <button
          @click="$modal.show(sendSupportMessageModalName)"
          class="btn btn-primary"
        >
          Supportnachricht senden
        </button>
        <button
          v-if="isBlockedForMails"
          @click="removeUserEmailLock()"
          class="btn btn-warning"
        >
          E-Mail-Sperre aufheben
        </button>
        <button
          v-else
          @click="$modal.show(sendMailModalName)"
          class="btn btn-primary"
        >
          E-Mail senden
        </button>
        <v-button
          v-if="isSuperadmin"
          @click.native="logoutUser()"
          :working="loggingOut"
          class="btn btn-warning"
          >Zwangslogout</v-button
        >
        <v-button
          @click.native="deleteUser(customer.name)"
          :working="deleting"
          class="btn btn-danger"
          >Löschen</v-button
        >
        <v-button
          v-if="isSuperadmin"
          @click.native="forceDeleteUser(customer.name)"
          :working="deleting"
          class="btn btn-danger"
          >Hart Löschen</v-button
        >
        <v-button
          @click.native="toggleUserDisabled"
          :working="settingUserDisabled"
          class="btn btn-danger"
          >{{ userDisabledText }}</v-button
        >
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <resource
          resource="customerProfile"
          :original="customer"
          :static-mode="true"
          :attributes="[
            {
              name: 'id',
              label: 'ID',
              type: 'StaticText'
            },
            {
              name: 'name',
              label: 'Name',
              type: 'StaticText'
            },
            {
              name: 'created_at',
              label: 'Registrierung',
              type: 'StaticText'
            },
            {
              name: 'last_login_at',
              label: 'letzter Login',
              type: 'StaticText'
            },
            {
              name: 'last_seen_at',
              label: 'letzte Besucheraktion',
              type: 'StaticText'
            },
            {
              name: 'last_seen_on',
              label: 'Zeit der letzten Aktion',
              type: 'StaticText'
            },
            {
              name: 'user',
              label: 'Verified',
              type: 'UserVerified'
            },
            {
              name: 'user|unsubscribed',
              label: 'Unsubscribed',
              type: 'StaticText',
              hideEmpty: true
            },
            {
              name: 'user|email_restricted',
              label: 'Email-Versand gesperrt',
              type: 'StaticText',
              hideEmpty: true
            },
            {
              name: 'balance',
              label: 'Währung vorhanden',
              type: 'StaticText'
            },
            {
              name: 'spent',
              label: 'Währung ausgegeben',
              type: 'StaticText'
            },
            {
              name: 'ins',
              label: 'INs (heute / total)',
              type: 'StaticText',
              isString: true
            },
            {
              name: 'outs',
              label: 'OUTs (heute / total)',
              type: 'StaticText',
              isString: true
            },
            {
              name: 'user|source',
              label: 'Quelle',
              type: 'StaticText',
              isString: true
            },
            {
              name: 'telegram_token',
              label: 'Telegram',
              type: 'TelegramConnection'
            }
          ]"
        >
          <div slot="title">
            <h4>Stammdaten</h4>
          </div>
          <v-button
            v-if="!customer.user.verified && !isDeleted"
            @click.native="sendVerifcationEmail"
            :working="sendingVerificationEmail"
            type="button"
            class="btn-primary"
          >
            Aktiveriungsemail erneut senden
          </v-button>
        </resource>
        <div class="card">
          <div class="card-header">
            <h4>E-Mail-Adresse</h4>
          </div>
          <div class="card-body">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-model="email"
                :disabled="isDeleted"
              />
            </div>
            <v-button
              v-if="!isDeleted"
              @click.native="persistEmail()"
              :working="changingEmail"
              type="button"
              class="btn-primary float-right"
              >Speichern</v-button
            >
          </div>
        </div>
        <div v-if="!isDeleted" class="card">
          <div class="card-header">
            <h4>Passwort</h4>
          </div>
          <div class="card-body">
            <div class="form-group">
              <input type="text" class="form-control" v-model="password" />
            </div>
            <v-button
              @click.native="persistPassword()"
              type="button"
              class="btn-primary float-right"
              >Speichern</v-button
            >
          </div>
        </div>
      </div>
      <div class="col-6">
        <resource
          v-if="!isDeleted"
          title="Ändern"
          resource="customerProfile"
          resourceName="Mitglied"
          :original="customer"
          :attributes="[
            {
              name: 'sex',
              label: 'Geschlecht',
              type: 'SexSelector'
            },
            {
              name: 'name',
              label: 'Name',
              checkChanged: true
            },
            {
              name: 'country_iso3166',
              label: 'Land',
              type: 'OptionSelector'
            },
            {
              name: 'zipcode',
              label: 'PLZ',
              col: 3
            },
            {
              name: 'birthday',
              label: 'Geburtsdatum',
              type: 'BirthdaySelector',
              withRandomSelector: false
            },
            {
              name: 'physique',
              label: 'Figur',
              type: 'OptionSelector'
            },
            {
              name: 'i_search_for_activity',
              label: 'Ich suche',
              type: 'MultiOptionSelector',
              multiSelect: true
            },
            {
              name: 'interested_in_gender',
              label: 'Interessiert an',
              type: 'SexSelector',
              multiSelect: true
            },
            {
              name: 'height_in_cm',
              label: 'Größe (cm)',
              type: 'SliderSelector',
              max: 220,
              min: 140
            }
          ]"
        >
          <div slot="title">
            <h4>Profil bearbeiten</h4>
          </div>
        </resource>
      </div>
    </div>
    <MediaEditCard v-if="!isDeleted" :profile="customer"></MediaEditCard>
    <div class="row">
      <div class="col-7">
        <v-table
          :url="'/api/v1/friends/' + id"
          :filter="[
            {
              name: 'where',
              attributes: {
                customer_profile_id1: id,
                accepted: 1
              }
            },
            {
              name: 'with',
              value: ['receiver']
            }
          ]"
          :attributes="[
            {
              attribute: 'receiver',
              type: 'LinkFriendCell',
              name: 'Freund'
            },
            {
              attribute: 'receiver.type',
              name: 'Fake',
              type: 'CheckMarkerCell'
            },
            {
              name: 'Aktion',
              type: 'DeleteFriendCell'
            }
          ]"
        ></v-table>
      </div>
      <div class="col-5">
        <div class="row">
          <div class="col-12">
            <v-table
              :url="'/api/v1/friends/' + id"
              :filter="[
                {
                  name: 'where',
                  attributes: {
                    customer_profile_id1: id,
                    accepted: null
                  }
                },
                {
                  name: 'with',
                  value: ['receiver']
                }
              ]"
              :attributes="[
                {
                  attribute: 'receiver',
                  type: 'LinkFriendCell',
                  name: 'Freund'
                },
                {
                  attribute: 'receiver.type',
                  name: 'Fake',
                  type: 'CheckMarkerCell'
                },
                {
                  name: 'Aktion',
                  type: 'DeleteFriendCell'
                }
              ]"
            >
              <div slot="title">Offene gesendet</div>
            </v-table>
            <v-table
              :url="'/api/v1/friends/' + id"
              :filter="[
                {
                  name: 'where',
                  attributes: {
                    customer_profile_id2: id,
                    accepted: null
                  }
                },
                {
                  name: 'with',
                  value: ['sender']
                }
              ]"
              :attributes="[
                {
                  attribute: 'sender',
                  type: 'LinkFriendCell',
                  name: 'Freund'
                },
                {
                  attribute: 'sender.type',
                  name: 'Fake',
                  type: 'CheckMarkerCell'
                },
                {
                  name: 'Aktion',
                  type: 'DeleteFriendCell'
                }
              ]"
            >
              <div slot="title">Offene eingehend</div>
            </v-table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/transaction"
          :filter="[
            {
              name: 'where',
              attributes: {
                customer_profile_id: id,
                amount: {
                  operator: '>',
                  value: 0
                }
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'id',
              name: 'ID',
              type: 'TransactionLinkCell'
            },
            {
              type: 'DateTimeCell',
              attribute: 'paid_at',
              name: 'Datum'
            },
            {
              attribute: 'amount',
              name: 'Einheiten'
            },
            {
              type: 'CurrencyCell',
              attribute: 'price',
              name: 'Preis'
            },
            {
              attribute: 'service_string',
              name: 'Methode'
            },
            {
              attribute: 'service_transaction_id',
              name: 'Buchungs-/Transaktionsnummer'
            },
            {
              type: 'TransactionConfirmCell',
              attribute: 'state',
              name: 'Gebucht?'
            }
          ]"
        >
          <div slot="title">Transaktionen</div>
        </v-table>
      </div>
    </div>
    <div class="row" v-if="!isDeleted">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4>Verwendbare Bezahlmethoden</h4>
          </div>
          <div class="card-body">
            <allowed-payment-methods
              :user="customer.user"
            ></allowed-payment-methods>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/message"
          :filter="[
            {
              name: 'with',
              value: ['sender', 'receiver', 'transaction']
            },
            {
              name: 'where',
              attributes: {
                sender_id: id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'id',
              name: 'ID'
            },
            {
              attribute: 'receiver',
              type: 'LinkFriendCell',
              name: 'Chatpartner'
            },
            {
              type: 'DialogLink',
              name: 'Dialog'
            },
            {
              attribute: 'in',
              name: 'IN/OUT',
              type: 'InOrOutCell'
            },
            {
              name: 'Inhalt',
              type: 'MessageContentCell'
            },
            {
              attribute: 'dEType',
              name: 'Typ'
            },
            {
              attribute: 'transaction.amount',
              name: 'Einheiten'
            },
            {
              attribute: 'created_at',
              name: 'Gesendet am',
              type: 'DateTimeCell'
            }
          ]"
        >
          <div slot="title">Nachrichten</div>
        </v-table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <customer-dialogs-table :customer="customer"></customer-dialogs-table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/logEntry"
          :filter="[
            {
              name: 'where',
              attributes: {
                user_id: customer.user.id
              }
            },
            {
              name: 'navigation'
            }
          ]"
          :attributes="[
            {
              attribute: 'method',
              name: 'Method'
            },
            {
              attribute: 'route',
              name: 'Route'
            },
            {
              attribute: 'values',
              name: 'Parameter'
            },
            {
              attribute: 'created_at',
              name: 'Vom',
              type: 'DateTimeCell'
            }
          ]"
        >
          <div slot="title">Navigation</div>
        </v-table>
      </div>
    </div>
    <div v-if="!isDeleted" class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/userSession"
          :filter="[
            {
              name: 'where',
              attributes: {
                user_id: customer.user.id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'ip',
              name: 'IP-Adresse'
            },
            {
              attribute: 'country_code',
              name: 'Land',
              type: 'FlagCell'
            },
            {
              attribute: 'session_id',
              name: 'Session-ID'
            },
            {
              attribute: 'user_agent',
              name: 'Browser- und Gerätedaten'
            },
            {
              attribute: 'created_at',
              name: 'Erstellt am',
              type: 'DateTimeCell'
            },
            {
              attribute: 'closed_at',
              name: 'Geschlossen am',
              type: 'DateTimeCell'
            },
            {
              attribute: 'duration',
              name: 'Zeitspanne'
            },
            {
              attribute: 'success',
              name: 'Erfolgreich eingeloggt',
              type: 'CheckMarkerCell'
            }
          ]"
        >
          <div slot="title">Anmeldungen</div>
        </v-table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v2-table
          :url="`/api/v1/emailLog?filter[to]=${customer.user.email}&paginate`"
          :headers="[
            {
              text: 'Id'
            },
            {
              text: 'User'
            },
            {
              text: 'Betreff'
            },
            {
              text: 'Typ'
            },
            {
              text: 'Datum'
            },
            {
              text: 'Nachricht'
            }
          ]"
        >
          <tr slot="row" slot-scope="{ item }">
            <td>{{ item.id }}</td>
            <e-mail-log-to-cell
              :model="item"
              :content="item.to"
            ></e-mail-log-to-cell>
            <td>{{ item.subject }}</td>
            <td>{{ item.type }}</td>
            <date-time-cell :content="item.created_at" />
            <modal-cell
              :attribute="{ mode: 'emailLog', modal: 'EMailLogModal' }"
              :model="item"
            />
          </tr>
        </v2-table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/emailBounce"
          :filter="[
            {
              name: 'where',
              attributes: {
                user_id: customer.user.id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'bounced_email_address',
              name: 'problematische Email-Adresse'
            },
            {
              attribute: 'bounce_reason',
              name: 'Grund'
            },
            {
              attribute: 'created_at',
              name: 'Zurück gekommen am',
              type: 'DateTimeCell'
            }
          ]"
        >
          <div slot="title">Zurückgekommene Emails</div>
        </v-table>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <resource
          resource="customerProfile"
          notification="Die Notizen wurden gespeichert"
          :original="customer"
          :attributes="[
            {
              name: 'internal_notes',
              label: 'Intern (admin -> admin)',
              type: 'TextareaSelector',
              rows: 5
            },
            {
              name: 'admin_notes',
              label: 'Admininfo (admin -> moderator)',
              type: 'TextareaSelector',
              rows: 5
            }
          ]"
        >
          <div slot="title">
            <h4>Notizen</h4>
          </div>
        </resource>
      </div>

      <div v-if="!isDeleted" class="col-6">
        <div class="card">
          <div class="card-header">
            <h4>Einstellungen</h4>
          </div>
          <div class="card-body">
            <customer-settings-notification
              :is-admin="true"
              :user="customer.user"
              :telegram-token="customer.telegram_token"
            ></customer-settings-notification>
          </div>
        </div>
      </div>
    </div>
    <modal :name="sendMailModalName">
      <section class="p-3">
        <div class="form-group">
          <textarea
            class="form-control"
            placeholder="Nachricht ..."
            v-model="mailMessage"
          ></textarea>
        </div>
        <button
          @click="sendMail()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Senden
        </button>
      </section>
    </modal>
    <modal :name="sendSupportMessageModalName">
      <section class="p-3">
        <div class="form-group">
          <textarea
            class="form-control"
            placeholder="Nachricht ..."
            v-model="supportMessage"
          ></textarea>
        </div>
        <button
          @click="sendSupportMessage()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Senden
        </button>
      </section>
    </modal>
    <modal
      :name="openChatModalName"
      class="chat-modal"
      :width="'70%'"
      :height="'70%'"
      @before-open="loadChatProfiles"
    >
      <section class="p-3" style="height:80%">
        <div class="form-group">
          <autocomplete
            v-if="chatProfiles.length > 0"
            id="chatPartnerSelect"
            v-model="profileName"
            inputClass="form-control"
            :list="chatProfiles"
            property="name"
            :threshold="2"
          ></autocomplete>
          <button
            @click="startChat()"
            type="button"
            class="btn btn-primary float-right"
          >
            Chat starten
          </button>
          <div class="clearfix"></div>
        </div>
        <dialog-content
          @message-sent="updateDialog"
          :key="counter"
          v-if="chatActive"
          :hideInputs="isDeleted"
          :isAsa="false"
          :idPartner="customer.id"
          :profile="selectedChatProfile"
          :support="false"
          :moderator="true"
        ></dialog-content>
      </section>
    </modal>
  </div>
</template>

<script>
import CustomerSettingsNotification from "@/components/Customer/settings/Notification.vue";
import AllowedPaymentMethods from "@/components/Customer/AllowedPaymentMethods.vue";
import DialogContent from "@/components/DialogContent.vue";
import Autocomplete from "autocomplete-vue";
import CustomerDialogsTable from "@/components/tables/CustomerDialogsTable.vue";
import MediaEditCard from "src/components/UIComponents/Cards/MediaEditCard.vue";
import DateTimeCell from "@/components/table/DateTimeCell";
import ModalCell from "@/components/table/ModalCell";
import EMailLogToCell from "@/components/table/EMailLogToCell";
import {
  getDateTimeHtml,
  getDateTimeHtmlAddMinutes,
  getTimeDifference
} from "@/js/date";

export default {
  components: {
    CustomerSettingsNotification,
    AllowedPaymentMethods,
    DialogContent,
    Autocomplete,
    CustomerDialogsTable,
    MediaEditCard,
    DateTimeCell,
    ModalCell,
    EMailLogToCell
  },
  created() {
    this.$store
      .dispatch("customerProfile/read", {
        filter: [
          {
            name: "where",
            attributes: {
              id: this.id
            }
          },
          {
            name: "with",
            value: "media"
          }
        ],
        appends: [
          "ins",
          "outs",
          "user.verify_duration",
          "user.source",
          "no_offline_email"
        ]
      })
      .then(() => {
        this.email = this.customer.user.email;

        if (this.customer.is_fake) {
          this.$router.push("/fake/kartei/" + this.customer.id);
        }
      });
  },
  data() {
    return {
      email: "",
      password: "",
      messageSender: "",
      disableModalActions: false,
      mailMessage: "",
      supportMessage: "",
      profileName: "",
      selectedChatProfile: null,
      chatActive: false,
      settingUserDisabled: false,
      deleting: false,
      changingEmail: false,
      loggingOut: false,
      sendingVerificationEmail: false,
      chatProfiles: [],
      counter: 0
    };
  },
  computed: {
    no_offline_email() {
      return this.customer.no_offline_email;
    },
    no_offline_email_tooltip() {
      return `Das Mitglied bekommt keine Benachtigungungs-E-Mails mehr von neuen Nachrichten in seinem Posteingang, weil es länger als ${Laravel.settings.maxOfflineDaysForEmail} Tage nicht mehr eingeloggt war.`;
    },
    online() {
      return this.$store.getters["online/profileOnline"](this.customer.id);
    },
    deleted_at() {
      return getDateTimeHtml(this.customer.deleted_at);
    },
    disabled_at() {
      return getDateTimeHtml(this.customer.user.disabled_at);
    },
    deletion_start_at() {
      return getDateTimeHtml(this.customer.user.deletion_at);
    },
    deletion_time() {
      return getTimeDifference(this.customer.user.deletion_at);
    },
    deletion_end_at() {
      return getDateTimeHtmlAddMinutes(
        this.customer.user.deletion_at,
        Laravel.settings.deletion_time
      );
    },
    id() {
      return Number(this.$route.params.id);
    },
    customer() {
      return this.$store.getters["customerProfile/find"](this.id);
    },
    isDeleted() {
      return this.customer.deleted_at !== null;
    },
    isDeletion() {
      return Boolean(this.customer.user.deletion_at);
    },
    isUnsubscribed() {
      return this.customer.user.unsubscribed;
    },
    isBlockedForMails() {
      return Boolean(this.customer.user.email_restricted);
    },
    modalPrefix() {
      return "mitgliederkartei";
    },
    isDisabled() {
      return Boolean(this.customer.user.disabled_at);
    },
    userDisabledText() {
      return this.isDisabled ? "Entsperren" : "Sperren";
    },
    sendMailModalName() {
      return `${this.modalPrefix}-send-mail`;
    },
    sendSupportMessageModalName() {
      return `${this.modalPrefix}-send-support-message`;
    },
    openChatModalName() {
      return `${this.modalPrefix}-open-chat`;
    },
    isSuperadmin() {
      return this.$store.getters["user/meHasPermissionTo"](
        "access_super_admin_area"
      );
    }
  },
  methods: {
    loginAsUser() {
      this.$http
        .post(`/api/v1/admin-actions/login-as-user/${this.customer.user_id}`)
        .then(({ data }) => {
          window.open(data);
        });
    },
    updateDialog() {
      this.counter++;
    },
    loadChatProfiles() {
      if (this.chatProfiles.length > 0) {
        return;
      }

      this.$http
        .get("/api/v1/customerProfile", {
          params: {
            filter: [
              {
                name: "forSelect"
              },
              {
                name: "withoutTrashed"
              }
            ]
          }
        })
        .then(({ data }) => {
          this.chatProfiles = data;
        });
    },
    sendVerifcationEmail() {
      if (this.customer.user.verified) {
        return;
      }

      this.sendingVerificationEmail = true;

      this.$http
        .post(
          `/api/v1/admin-actions/send-verification-email/${this.customer.user_id}`
        )
        .then(() => {
          this.$notify({
            title: "Aktiveriungsemail wurde erneut versendet",
            type: "success"
          });
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$notify({
              title: error.response.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.sendingVerificationEmail = false;
        });
    },
    toggleUserDisabled() {
      if (this.isDisabled) {
        this.enableUser();
      } else {
        this.disableUser();
      }
    },
    disableUser() {
      if (this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.settingUserDisabled = true;

      this.$http
        .post("/api/v1/userDisabled", {
          user_id: this.customer.user.id,
          message: null
        })
        .then(({ data }) => {
          this.$store.commit("customerProfile/updateModel", {
            modelId: this.customer.id,
            attributePath: "user.disabled_at",
            data: data
          });
          this.$notify({
            title: `${this.customer.name} wurde gesperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.settingUserDisabled = false;
        });
    },
    enableUser() {
      if (!this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.settingUserDisabled = true;

      this.$http
        .delete(`/api/v1/userDisabled/${this.customer.user.id}`)
        .then(() => {
          this.$store.commit("customerProfile/updateModel", {
            modelId: this.customer.id,
            attributePath: "user.disabled_at",
            data: undefined
          });
          this.$notify({
            title: `${this.customer.name} wurde entsperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.settingUserDisabled = false;
        });
    },
    removeUserEmailLock() {
      this.$http
        .post("/api/v1/emailBounce/update", {
          user_id: this.customer.user.id,
          bounced_email_address: this.customer.user.email,
          restriction: false
        })
        .then(() => {
          this.$store.commit("customerProfile/updateModel", {
            modelId: this.customer.id,
            attributePath: "user.email_restricted",
            data: ""
          });
          this.$notify({
            title: `E-Mail-Sperre für ${this.customer.name} wurde aufgehoben`,
            type: "success"
          });
        });
    },
    deleteUser(customerName) {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }

      this.deleting = true;
      this.$http
        .post("/api/v1/admin-actions/delete/user/" + this.customer.user_id)
        .then(() => {
          this.$notify({
            title: `${customerName} wurde gelöscht`,
            type: "success"
          });

          this.$router.push("/mitglieder/list");
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    forceDeleteUser(customerName) {
      if (this.deleting) {
        return;
      }

      if (!confirm("Sicher?")) {
        return;
      }

      this.deleting = true;

      this.$http
        .post("/api/v1/admin-actions/forceDelete/user/" + this.customer.user_id)
        .then(() => {
          this.$notify({
            title: `${customerName} wurde gelöscht`,
            type: "success"
          });

          this.$router.push("/mitglieder/list");
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$notify({
              text: error.response.data,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    logoutUser() {
      if (this.loggingOut) {
        return;
      }

      this.loggingOut = true;

      this.$http
        .post("/api/v1/userLogout/" + this.customer.user_id)
        .then(() => {
          this.$notify({
            title: `${this.customer.name} wurde ausgeloggt`,
            type: "success"
          });
        })
        .finally(() => {
          this.loggingOut = false;
        });
    },
    persistEmail() {
      if (this.changingEmail) {
        return;
      }
      this.changingEmail = true;
      this.$http
        .post("/api/v1/admin-actions/change-email/" + this.customer.user.id, {
          email: this.email
        })
        .then(() => {
          this.$notify({
            title: `E-Mail-Adresse aktualisiert`,
            type: "success"
          });
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$notify({
              title: error.response.data.message,
              text: error.response.data.errors.email.join(" "),
              type: "error"
            });
          }
        })
        .finally(() => {
          this.changingEmail = false;
        });
    },
    persistPassword() {
      this.$http
        .post(
          "/api/v1/admin-actions/change-password/" + this.customer.user.id,
          {
            password: this.password
          }
        )
        .then(() => {
          this.$notify({
            title: `Passwort aktualisiert`,
            type: "success"
          });
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$notify({
              title: error.response.data.message,
              text: error.response.data.errors.password.join(" "),
              type: "error"
            });
          }
        });
    },
    sendMail() {
      this.disableModalActions = true;
      this.$http
        .post(
          "/api/v1/admin-actions/administration-mail/" + this.customer.user.id,
          {
            message: this.mailMessage
          }
        )
        .then(() => {
          this.$notify({
            title: `${this.customer.name} hat eine E-Mail erhalten`,
            type: "success"
          });
          this.mailMessage = "";
        })
        .finally(() => {
          this.disableModalActions = false;
          this.$modal.hide(this.sendMailModalName);
        });
    },
    sendSupportMessage() {
      this.disableModalActions = true;
      this.$store
        .dispatch("message/create", {
          url: "/api/v1/message",
          data: {
            body: this.supportMessage,
            receiver_id: this.customer.id,
            sender_id: Laravel.support.id,
            type: 5
          }
        })
        .then(() => {
          this.$notify({
            title: `${this.customer.name} hat eine Support Nachricht erhalten`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
          this.$modal.hide(this.sendSupportMessageModalName);
        });
    },
    startChat() {
      if (this.profileName) {
        this.chatActive = false;
        this.$store
          .dispatch("customerProfile/read", [
            {
              name: "where",
              attributes: {
                name: this.profileName
              }
            }
          ])
          .then(() => {
            this.selectedChatProfile = this.$store.getters[
              "customerProfile/find"
            ](this.profileName, "name");

            if (!this.selectedChatProfile) {
              this.$notify({
                title: `Benutzer existiert nicht.`,
                type: "error"
              });
            } else {
              this.chatActive = true;
            }
          });
      } else {
        this.$notify({
          title: `Es wurde kein Nutzer gewählt.`,
          type: "error"
        });
      }
    }
  },
  watch: {
    id(newId, oldId) {
      this.$store.commit("customerProfile/delete", oldId);
      this.$store
        .dispatch("customerProfile/read", [
          {
            name: "where",
            attributes: {
              id: newId
            }
          }
        ])
        .then(() => {
          this.email = this.customer.user.email;
        });
    }
  }
};
</script>
